import { useContext } from "react";

import { useParams } from "react-router-dom";

import Box from "@/components/Box";
import DataLoader from "@/components/DataLoader";
import { OrderDetailsContent, OrderNotFound } from "@/components/orders/OrderDetailPage";
import Stack from "@/tpo/Stack";
import { ViewerContext } from "@/tpo/Viewer";
import { useTheme } from "styled-components";

import { WardTabs } from "../shared/Template";
import Template from "../shared/Template";
import { ORDER_QUERY } from "./graphql";

export default function OrderDetailPage() {
  const { id } = useParams();
  const { userId } = useContext(ViewerContext);
  const theme = useTheme();
  return (
    <Template selectedTab="orders" docTitle="Orders">
      <DataLoader
        query={ORDER_QUERY}
        variables={{
          id,
          userId
        }}
        render={({ order }) => (
          <>
            {order ? (
              <Box pt={theme.spacing.section.pt} pb={theme.spacing.section.pb} px={20}>
                <Box
                  bg="white"
                  borderRadius={5}
                  maxWidth={1020}
                  mx="auto"
                  pt={[30, 30, 60]}
                  pb={[50, 50, 80]}
                  px={[20, 20, 40]}
                >
                  <Stack gap={[20, 20, 40]} maxWidth={760} mx="auto">
                    <OrderDetailsContent {...order} order={order} />
                  </Stack>
                </Box>
              </Box>
            ) : (
              <OrderNotFound tabs={<WardTabs />} />
            )}
          </>
        )}
      />
    </Template>
  );
}
